import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m4.593 20.061-.643-.643 1.068-4.275L16.156 4.004h2.464l1.387 1.387v2.464L8.868 18.993l-4.275 1.068zM17.175 8.12l-1.283-1.283-9.234 9.232-.056.23 1.113 1.112.226-.056 9.234-9.237v.002z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }